import { render } from "./TagMatrix.vue?vue&type=template&id=5902cdb6&scoped=true"
import script from "./TagMatrix.vue?vue&type=script&lang=js"
export * from "./TagMatrix.vue?vue&type=script&lang=js"

import "./TagMatrix.vue?vue&type=style&index=0&id=5902cdb6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5902cdb6"]])

export default __exports__